<div class="MainContainer animated fadeIn">
    <div class="MainCompanyTitle" style="margin-bottom: 0;">
        <p class="SectionTitle" style="margin-top: 0%;">{{ 'DashMenu.SettingsMenu.CompanySettings' | translate }} {{this.parent.Company.Name}}</p>
    </div>

    <div class="ModernPopupOverlay" *ngIf="ShowANAFRedirectionNotification" (click)="ShowANAFRedirectionNotification = false;">
     <div class="ModernPopup small" (click)="$event.stopPropagation()">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">info</i>
          <span>{{ 'ShowANAFRedirectionNotification' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowANAFRedirectionNotification = false;">
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="ModernPopupBody">
        {{ 'ShowANAFRedirectionNotificationDescription' | translate }}
      </div>
      <div class="ModernPopupFooter">
        <button [disabled]="this.parent.loading" class="ModernPopupButton secondary" (click)="ShowANAFRedirectionNotification = false;">
          <i class="material-icons">close</i>
          <span>{{ 'Configuration.DeleteNoButton' | translate }}</span>
        </button>
        <button [disabled]="this.parent.loading" class="ModernPopupButton primary" (click)="ResetANAFAuthCodeAndEToken();">
          <i class="material-icons">open_in_new</i>
          <span>{{ 'ANAFRedirectionNotificationButton' | translate }}</span>
        </button>
      </div>
     </div>
    </div>

    <div class="ModernPopupOverlay" *ngIf="ShowDeleteSMTPQuestion" (click)="ShowDeleteSMTPQuestion = false; currentSpending = null;">
     <div class="ModernPopup small" (click)="$event.stopPropagation()">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">delete</i>
          <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowDeleteSMTPQuestion = false; currentSpending = null;">
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="ModernPopupBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
      <div class="ModernPopupFooter">
        <button [disabled]="this.parent.loading" class="ModernPopupButton secondary" (click)="ShowDeleteSMTPQuestion = false; CurrenctSMTP = null;">
          <i class="material-icons">close</i>
          <span>{{ 'Configuration.DeleteNoButton' | translate }}</span>
        </button>
        <button [disabled]="this.parent.loading" class="ModernPopupButton danger" (click)="ShowDeleteSMTPQuestion = false;DeleteSMTP(CurrenctSMTP.ID);">
          <i class="material-icons">delete</i>
          <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
        </button>
      </div>
     </div>
    </div>

    <div class="ModernPopupOverlay" *ngIf="ShowDeleteSMTPEmailQuestion" (click)="ShowDeleteSMTPEmailQuestion = false; currentSpending = null;">
     <div class="ModernPopup small" (click)="$event.stopPropagation()">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">delete</i>
          <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowDeleteSMTPEmailQuestion = false; currentSpending = null;">
          <i class="material-icons">close</i>
        </button>
      </div>
      <div class="ModernPopupBody">
        {{ 'Configuration.DeleteQuestionDescription' | translate }}
      </div>
      <div class="ModernPopupFooter">
        <button [disabled]="this.parent.loading" class="ModernPopupButton secondary" (click)="ShowDeleteSMTPEmailQuestion = false; CurrenctSMTPEmail = null;">
          <i class="material-icons">close</i>
          <span>{{ 'Configuration.DeleteNoButton' | translate }}</span>
        </button>
        <button [disabled]="this.parent.loading" class="ModernPopupButton danger" (click)="ShowDeleteSMTPEmailQuestion = false;DeleteSMTPEmail(CurrenctSMTPEmail.ID);">
          <i class="material-icons">delete</i>
          <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
        </button>
      </div>
     </div>
    </div>

    <div class="BulkDeleteMasterContainer" *ngIf="ShowBulkDeleteMasterContainer">
      <div class="PopUpCloseContainer" (click)="ShowBulkDeleteMasterContainer = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{'DeletingMasterEntities' | translate}}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="DeleteMasterRow" *ngFor="let e of this.DeletingMasterEntities; let i=index;">
          <p class="DocumentCategory">{{'Type' | translate}}: <span style="color: #2CA70F;">{{e.DocumentCategory.Name}}</span></p>
          <p class="DocumentCategory">{{'TotalDetected' | translate}}: <span style="color: #0082e6;">{{e.Filter.Pager.TotalCount}}</span></p>
          <i (click)="GetDeletingEntities(e);" class="material-icons DocumentCategoryIcon" matTooltip="{{ 'ViewDetails' | translate }}" matTooltipClass='neutral-tool-tip'>open_in_browser</i>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="this.OpenMFA();" [disabled]="parent.loading" matTooltip="{{ 'DeleteDataButtonDesc' | translate }}" matTooltipClass='neutral-tool-tip' class="ModernButton danger PopGeneralCommandButton">
            <span>{{'DeleteDataButton' | translate}}</span>
      </button>
      </div>
    </div>

    <div class="BulkDeleteMasterContainer" *ngIf="ShowDeletingMasterEntitiesErrorResults">
      <div class="PopUpCloseContainer" (click)="ShowDeletingMasterEntitiesErrorResults = false;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{'ErrorList' | translate}}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="DeleteMasterRow" *ngFor="let e of this.ErrorsList;" style="cursor: default;" (click)="OpenDeletingEntitiesErrors(e);">
          <p class="DocumentCategory">{{'Type' | translate}}: <span style="color: #2CA70F;">{{e.DocumentCategory.Name}}</span></p>
          <p class="DocumentCategory">{{'TotalDetected' | translate}}: <span style="color: #0082e6;">{{e.Filter.Pager.TotalCount}}</span></p>
          <i class="material-icons DocumentCategoryIcon" style="color: red;">error_outline</i>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="ShowDeletingMasterEntitiesErrorResults = false;" [disabled]="parent.loading" matTooltipClass='neutral-tool-tip' class="ModernButton primary PopGeneralCommandButton">
            <span>{{'Confirm' | translate}}</span>
      </button>
      </div>
    </div>

    <div class="BulkDeleteMasterContainer" *ngIf="ShowDeletingMasterEntitiesErrorResultsDetails">
      <div class="PopUpCloseContainer" (click)="ShowDeletingMasterEntitiesErrorResultsDetails = false;ShowDeletingMasterEntitiesErrorResults = true;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{'DeletingMasterEntities' | translate}}</p>
       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="DeleteMasterRow" *ngFor="let doc of this.SelectedDeletingMasterEntity.Documents; let i=index;" matTooltip="{{doc.ErrorMessage}}" matTooltipClass='neutral-tool-tip'>
          <p class="DocumentCategory">{{SelectedDeletingMasterEntity.DocumentCategory.Name}}: <span style="color: red;">{{doc.DisplayValue}} {{'FromWord' | translate}} {{doc.EventDate}}</span></p>
          <i class="material-icons DeleteMasterRowDeleteSign" style="color: red;">error_outline</i>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="ShowDeletingMasterEntitiesErrorResultsDetails = false;ShowDeletingMasterEntitiesErrorResults = true;" [disabled]="parent.loading" class="ModernButton primary PopGeneralCommandButton">
          <span>{{'Confirm' | translate}}</span>
        </button>
      </div>

    </div>

    <div class="BulkDeleteMasterContainer EntitiesContainer" *ngIf="DeletingEntitiesMasterContainer">
      <div class="PopUpCloseContainer" (click)="DeletingEntitiesMasterContainer = false;ShowBulkDeleteMasterContainer = true;">
        <i class="material-icons">close</i>
      </div>

      <div class="PopUpTitleContainer">
        <p style="color: #0082e6;">{{'DeletingMasterEntities' | translate}}</p>

        <div class="TotalDocCountContainer">
          <span style="float: right;">{{this.SelectedDeletingMasterEntity.Documents.length}} {{'OfWord' | translate}} {{this.SelectedDeletingMasterEntity.Filter.Pager.TotalCount}} {{SelectedDeletingMasterEntity.DocumentCategory.Name}} ({{'Page' | translate}}: {{this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.SelectedDeletingMasterEntity.Filter.Pager.Pages}})</span>
          <div class="PageSizeContainer">
            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'PageSize' | translate }}*</label>
              <div class="PartnerSearchBar">
                <input type="number" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="SelectedDeletingMasterEntity.Filter.Pager.PageSize" (change)="GetDeletingEntities(SelectedDeletingMasterEntity);">
              </div>
            </div>
          </div>
        </div>

        <div class="TotalDocCountContainer">
          <div class="TopPagingButton unSelectable" *ngIf="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex != 1;" (click)="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex = this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex - 1;GetDeletingEntities(SelectedDeletingMasterEntity);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <div class="TopPagingButton unSelectable" *ngIf="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex != this.SelectedDeletingMasterEntity.Filter.Pager.Pages;" (click)="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex = this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex + 1;GetDeletingEntities(SelectedDeletingMasterEntity);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.SelectedDeletingMasterEntity.Filter.Pager.PageIndex == this.SelectedDeletingMasterEntity.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>

       </div>

       <div class="PopUpBody" style="margin-top: 20px;">
        <div class="DeleteMasterRow" *ngFor="let doc of this.SelectedDeletingMasterEntity.Documents; let i=index;" [ngClass]="{'leftOutRow': doc.IsSelected == false}" (click)="SelectDeselectDeletingDocument(doc, SelectedDeletingMasterEntity.DocumentCategory.ID);">
          <p class="DocumentCategory">{{SelectedDeletingMasterEntity.DocumentCategory.Name}}: <span style="color: #2CA70F;">{{doc.DisplayValue}} {{'FromWord' | translate}} {{doc.EventDate}}</span></p>
          <i class="material-icons DeleteMasterRowDeleteSign" *ngIf="doc.IsSelected">close</i>
        </div>
      </div>

      <div class="PopUpCommands">
        <button (click)="DeletingEntitiesMasterContainer = false;ShowBulkDeleteMasterContainer = true;" [disabled]="parent.loading" class="ModernButton accent PopGeneralCommandButton">
          <span>{{'Confirm' | translate}}</span>
        </button>
      </div>

    </div>

    <div class="example-form animated fadeInDown" *ngIf="this.ShowMFA" style="background: #fff;left: 35%;">
  
      <button [disabled]="loadingMFA" class="ModernButton outline" (click)="this.ShowMFA = false;this.ShowBulkDeleteMasterContainer = true;">{{ 'Login.BackButton' | translate }}</button>
      <p class="LoginFormTitle">{{ 'EnterToken' | translate }}</p>
  
      <div class="MFAImage">
        <svg class="MFAImageSVG" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M256 127.998C256 198.696 198.694 256 127.997 256 57.304 256 0 198.696 0 127.998 0 57.305 57.304 0 127.997 0 198.694 0 256 57.305 256 127.998z" fill="#EC1C24"/><path d="M117.024 100.89l30.691 30.68c4.43 4.436 11.623 4.436 16.064 0 4.431-4.435 4.441-11.622 0-16.058L133.086 84.82C111.125 62.854 75.631 62.5 53.204 83.704a9.536 9.536 0 0 0-.605.548c-.098.098-.178.202-.275.29-.1.096-.202.182-.297.278-.194.193-.371.396-.54.597-21.215 22.437-20.85 57.932 1.113 79.897L83.292 196c4.44 4.433 11.623 4.433 16.062 0 4.442-4.437 4.442-11.633.011-16.06l-30.693-30.691c-13.398-13.393-13.488-35.129-.278-48.637 13.506-13.21 35.23-13.114 48.63.279zm39.612-40.873c-4.435 4.437-4.435 11.623.012 16.059l30.681 30.693c13.39 13.392 13.477 35.125.268 48.636-13.51 13.2-35.227 13.112-48.623-.282l-30.692-30.689c-4.438-4.437-11.633-4.437-16.066 0-4.443 4.433-4.443 11.642 0 16.065l30.682 30.694c21.968 21.965 57.458 22.322 79.889 1.116.208-.184.404-.355.61-.549.094-.095.182-.192.273-.29.1-.095.197-.183.29-.289.197-.183.365-.384.54-.594 21.215-22.428 20.86-57.911-1.102-79.889l-30.692-30.682c-4.436-4.443-11.638-4.443-16.07.001z" fill="#FFF"/></svg>
      </div>
  
      <div class="PartnerSearchBar" style="width: 100%;margin-bottom: 12px;">
        <i class="material-icons search-icon">vpn_key</i>
        <input type="text" autocomplete="off" class="PartnerSearchInput" [disabled]="loading" placeholder="{{ 'MFAToken' | translate }}" [(ngModel)]="this.MFAToken" required>
      </div>

      <div class="PartnerSearchBar" style="width: 100%;margin-bottom: 12px;">
        <i class="material-icons search-icon">password</i>
        <input type="password" autocomplete="off" class="PartnerSearchInput" [disabled]="loading" placeholder="{{ 'PIN' | translate }}" [(ngModel)]="this.parent.AppPIN" required>
      </div>

          <button [disabled]="loadingMFA" class="ModernButton accent tokenButton" (click)="this.GetMFAResult();">
            <i class="material-icons ButtonCenterImage">check</i>
            <span>{{ 'VerifyToken' | translate }}</span>
          </button>
        <div class="ModernProgress" *ngIf="loadingMFA"></div>
    </div>

    <div class="example-form animated fadeInDown" *ngIf="this.ShowMFACompanyDelete" style="background: #fff;left: 35%;">
  
      <button [disabled]="loadingMFA" class="ModernButton outline" (click)="this.ShowMFACompanyDelete = false;">{{ 'Login.BackButton' | translate }}</button>
      <p class="LoginFormTitle">{{ 'EnterToken' | translate }}</p>
  
      <div class="MFAImage">
        <svg class="MFAImageSVG" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"><path d="M256 127.998C256 198.696 198.694 256 127.997 256 57.304 256 0 198.696 0 127.998 0 57.305 57.304 0 127.997 0 198.694 0 256 57.305 256 127.998z" fill="#EC1C24"/><path d="M117.024 100.89l30.691 30.68c4.43 4.436 11.623 4.436 16.064 0 4.431-4.435 4.441-11.622 0-16.058L133.086 84.82C111.125 62.854 75.631 62.5 53.204 83.704a9.536 9.536 0 0 0-.605.548c-.098.098-.178.202-.275.29-.1.096-.202.182-.297.278-.194.193-.371.396-.54.597-21.215 22.437-20.85 57.932 1.113 79.897L83.292 196c4.44 4.433 11.623 4.433 16.062 0 4.442-4.437 4.442-11.633.011-16.06l-30.693-30.691c-13.398-13.393-13.488-35.129-.278-48.637 13.506-13.21 35.23-13.114 48.63.279zm39.612-40.873c-4.435 4.437-4.435 11.623.012 16.059l30.681 30.693c13.39 13.392 13.477 35.125.268 48.636-13.51 13.2-35.227 13.112-48.623-.282l-30.692-30.689c-4.438-4.437-11.633-4.437-16.066 0-4.443 4.433-4.443 11.642 0 16.065l30.682 30.694c21.968 21.965 57.458 22.322 79.889 1.116.208-.184.404-.355.61-.549.094-.095.182-.192.273-.29.1-.095.197-.183.29-.289.197-.183.365-.384.54-.594 21.215-22.428 20.86-57.911-1.102-79.889l-30.692-30.682c-4.436-4.443-11.638-4.443-16.07.001z" fill="#FFF"/></svg>
      </div>
  
      <div class="PartnerSearchBar" style="width: 100%;margin-bottom: 12px;">
        <i class="material-icons search-icon">vpn_key</i>
        <input type="text" autocomplete="off" class="PartnerSearchInput" [disabled]="loading" placeholder="{{ 'MFAToken' | translate }}" [(ngModel)]="this.MFAToken" required>
      </div>

      <div class="PartnerSearchBar" style="width: 100%;margin-bottom: 12px;">
        <i class="material-icons search-icon">password</i>
        <input type="password" autocomplete="off" class="PartnerSearchInput" [disabled]="loading" placeholder="{{ 'PIN' | translate }}" [(ngModel)]="this.parent.AppPIN" required>
      </div>

          <button (click)="GetMFAResultCompanyDelete();" [disabled]="loadingMFA" class="ModernButton danger tokenButton" matTooltip="{{ 'DeleteDataButtonDesc' | translate }}" matTooltipClass='neutral-tool-tip'>
            <i class="material-icons ButtonCenterImage">check</i>
            <span>{{ 'DeleteWholeCompany' | translate }}</span>
          </button>
        <div class="ModernProgress" *ngIf="loadingMFA"></div>
    </div>

    <div class="overlay" *ngIf="ShowANAFRedirectionNotification || ShowMFACompanyDelete || ShowDeletingMasterEntitiesErrorResultsDetails || ShowDeletingMasterEntitiesErrorResults || DeletingEntitiesMasterContainer || ShowMFA || ShowBulkDeleteMasterContainer || ShowNewCompanyRelationshipContainer || ShowDeleteSMTPEmailQuestion || ShowDeleteSMTPQuestion || showAddNewAddressPopUp || showAddNewAgentPopUp || ShowDeleteBankAccountQuestion || ShowDeleteAdministrationQuestion || ShowShippingAddressPopup || ShowDeleteShippingAddressQuestion"></div>

    <div class="ModernPopupOverlay" *ngIf="ShowNewCompanyRelationshipContainer" (click)="ShowNewCompanyRelationshipContainer = false;">
     <div class="ModernPopup large" (click)="$event.stopPropagation()">
      <div class="ModernPopupHeader">
        <div class="ModernPopupTitle">
          <i class="material-icons">hub</i>
          <span>{{ 'NewCompanyRelationship' | translate }}</span>
        </div>
        <button class="ModernPopupClose" (click)="ShowNewCompanyRelationshipContainer = false;">
          <i class="material-icons">close</i>
        </button>
      </div>

      <div class="ModernPopupBody">
        <div class="fullWidthContainer">
          <div class="PopUpBodyOneThirddContainer">

           <div class="fullWidthContainer">
            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'MainCompany' | translate }}</label>
              <div class="CustomDropdownContainer">
                <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'relMainCompany'" (click)="openDropdownId = null"></div>
                <div class="CustomDropdownBar" (click)="toggleDropdown('relMainCompany')">
                  <i class="material-icons dropdown-icon-left">domain</i>
                  <input type="text" class="CustomDropdownInput" [value]="Company?.Name || ''" readonly />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="openDropdownId === 'relMainCompany'">
                  <div class="CustomDropdownResult" (click)="Company = Company; openDropdownId = null;">
                    <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{Company.Name}}</span></div>
                  </div>
                </div>
              </div>
            </div>
           </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'SlaveCompany' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'relSlaveCompany'" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('relSlaveCompany')">
                    <i class="material-icons dropdown-icon-left">domain</i>
                    <input type="text" class="CustomDropdownInput" [value]="SlaveCompany?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="openDropdownId === 'relSlaveCompany'">
                    <div class="CustomDropdownResult" *ngFor="let c of Companies" (click)="SlaveCompany = c; openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{c.Name}}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="PopUpBodyOneThirddContainer" *ngIf="Company !== undefined && SlaveCompany !== undefined;">

           <div class="fullWidthContainer">
            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'MasterAdministration' | translate }}</label>
              <div class="CustomDropdownContainer">
                <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'relMasterAdmin'" (click)="openDropdownId = null"></div>
                <div class="CustomDropdownBar" (click)="toggleDropdown('relMasterAdmin')">
                  <i class="material-icons dropdown-icon-left">account_balance</i>
                  <input type="text" class="CustomDropdownInput" [value]="MasterAdministration?.Name || ''" readonly />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="openDropdownId === 'relMasterAdmin'">
                  <div class="CustomDropdownResult" *ngFor="let a of this.Company.Administrations" (click)="MasterAdministration = a; openDropdownId = null;">
                    <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{a.Name}}</span></div>
                  </div>
                </div>
              </div>
            </div>
           </div>

           <div class="fullWidthContainer">
            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'SlaveAdministration' | translate }}</label>
              <div class="CustomDropdownContainer">
                <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'relSlaveAdmin'" (click)="openDropdownId = null"></div>
                <div class="CustomDropdownBar" (click)="toggleDropdown('relSlaveAdmin')">
                  <i class="material-icons dropdown-icon-left">account_balance</i>
                  <input type="text" class="CustomDropdownInput" [value]="SlaveAdministration?.Name || ''" readonly />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="openDropdownId === 'relSlaveAdmin'">
                  <div class="CustomDropdownResult" *ngFor="let a of this.SlaveCompany.Administrations" (click)="SlaveAdministration = a; openDropdownId = null;">
                    <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{a.Name}}</span></div>
                  </div>
                </div>
              </div>
            </div>
           </div>

          </div>

          <div class="PopUpBodyOneThirddContainer" *ngIf="SlaveAdministration !== undefined && MasterAdministration !== undefined;">

            <div class="fullWidthContainer">
             <div class="ModernFormGroup">
               <label class="ModernFormLabel">{{ 'MasterSeries' | translate }}</label>
               <div class="CustomDropdownContainer">
                 <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'relMasterSeries'" (click)="openDropdownId = null"></div>
                 <div class="CustomDropdownBar" (click)="toggleDropdown('relMasterSeries')">
                   <i class="material-icons dropdown-icon-left">tag</i>
                   <input type="text" class="CustomDropdownInput" [value]="MasterSeries ? (MasterSeries.Series + ' (' + MasterSeries.GeneralDocTypeObject.Name + ')') : ''" readonly />
                   <i class="material-icons dropdown-icon">arrow_drop_down</i>
                 </div>
                 <div class="CustomDropdownResults" *ngIf="openDropdownId === 'relMasterSeries'">
                   <div class="CustomDropdownResult" *ngFor="let a of this.Company.AccountingSeries" (click)="MasterSeries = a; openDropdownId = null;">
                     <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{a.Series}} ({{a.GeneralDocTypeObject.Name}})</span></div>
                   </div>
                 </div>
               </div>
             </div>
            </div>

            <div class="fullWidthContainer">
             <div class="ModernFormGroup">
               <label class="ModernFormLabel">{{ 'SlaveSeries' | translate }}</label>
               <div class="CustomDropdownContainer">
                 <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'relSlaveSeries'" (click)="openDropdownId = null"></div>
                 <div class="CustomDropdownBar" (click)="toggleDropdown('relSlaveSeries')">
                   <i class="material-icons dropdown-icon-left">tag</i>
                   <input type="text" class="CustomDropdownInput" [value]="SlaveSeries ? (SlaveSeries.Series + ' (' + SlaveSeries.GeneralDocTypeObject.Name + ')') : ''" readonly />
                   <i class="material-icons dropdown-icon">arrow_drop_down</i>
                 </div>
                 <div class="CustomDropdownResults" *ngIf="openDropdownId === 'relSlaveSeries'">
                   <div class="CustomDropdownResult" *ngFor="let a of this.SlaveCompany.AccountingSeries" (click)="SlaveSeries = a; openDropdownId = null;">
                     <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{a.Series}} ({{a.GeneralDocTypeObject.Name}})</span></div>
                   </div>
                 </div>
               </div>
             </div>
            </div>

           </div>
        </div>
      </div>

      <div class="ModernPopupFooter">
        <button class="ModernPopupButton secondary" (click)="ShowNewCompanyRelationshipContainer = false;">
          <i class="material-icons">close</i>
          <span>{{ 'Cancel' | translate }}</span>
        </button>
        <button (click)="AddCompanyRelationShip();" [disabled]="this.parent.loading" *ngIf="SlaveAdministration !== undefined && MasterAdministration !== undefined && SlaveSeries !== undefined && MasterSeries !== undefined;" matTooltip="{{ 'AddRelationship' | translate }}" class="ModernPopupButton primary">
          <i class="material-icons">add</i>
          <span>{{ 'AddRelationship' | translate }}</span>
        </button>
        <button disabled *ngIf="SlaveAdministration === undefined || MasterAdministration === undefined || SlaveSeries === undefined || MasterSeries === undefined;" matTooltip="{{ 'AddRelationship' | translate }}" class="ModernPopupButton primary">
          <i class="material-icons">add</i>
          <span>{{ 'AddRelationship' | translate }}</span>
        </button>
      </div>
     </div>
    </div>

    <div class="ModernPopupOverlay" *ngIf="showAddNewAddressPopUp" (click)="showAddNewAddressPopUp = false;">
     <div class="ModernPopup medium" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons">add_location_alt</i>
            <span>{{ 'Configuration.AddAddress' | translate }}</span>
          </div>
          <button class="ModernPopupClose" (click)="showAddNewAddressPopUp = false;">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="ModernPopupBody">
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
          <form [formGroup]="newAddress">

            <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>

            <div class="ModernPopupGrid">
              <div class="ModernFormGroup ModernFormGroupFull">
                <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'addAddrCountry'" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('addAddrCountry')">
                    <i class="material-icons dropdown-icon-left">public</i>
                    <input type="text" class="CustomDropdownInput" [value]="newAddressCountry?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="openDropdownId === 'addAddrCountry'">
                    <div class="CustomDropdownResult" *ngFor="let c of parent.masterData.Countries" (click)="newAddressCountry = c; newAddress.controls['Country'].setValue(c); openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{c.Name}}</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.StateProvince' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">map</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" formControlName="StateProvince">
                </div>
              </div>

              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.City' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">location_city</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" formControlName="City">
                </div>
              </div>

              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.AddressLine' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">home</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" formControlName="AddressLine">
                </div>
              </div>

              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'ZipCode' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">markunread_mailbox</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" formControlName="ZipCode">
                </div>
              </div>
            </div>

          </form>
  
        </div>
  
        <div class="ModernPopupFooter">
          <button class="ModernPopupButton secondary" (click)="showAddNewAddressPopUp = false;">
            <i class="material-icons">close</i>
            <span>{{ 'Cancel' | translate }}</span>
          </button>
          <button [disabled]="parent.loading" matTooltip="Submit Partner" class="ModernPopupButton primary" (click)="AddNewAddress();">
            <i class="material-icons">add</i>
            <span>{{ 'Configuration.AddAddress' | translate }}</span>
          </button>
        </div>
     </div>
      </div>

      <div class="ModernPopupOverlay" *ngIf="showAddNewAgentPopUp" (click)="showAddNewAgentPopUp = false;">
       <div class="ModernPopup medium" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons">person_add</i>
            <span>{{ 'Configuration.AddAgent' | translate }}</span>
          </div>
          <button class="ModernPopupClose" (click)="showAddNewAgentPopUp = false;">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="ModernPopupBody">
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
          <form [formGroup]="newAgent">
    
            <div class="PopUpBodySemiTextBox">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Configuration.AllocatedAddress' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'agentAddress'" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('agentAddress')">
                    <i class="material-icons dropdown-icon-left">location_on</i>
                    <input type="text" class="CustomDropdownInput" [value]="newAgentAddress ? (newAgentAddress.Country?.Name + ' ' + newAgentAddress.StateProvince + ' ' + newAgentAddress.City + ' ' + newAgentAddress.AddressLine) : ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="openDropdownId === 'agentAddress'">
                    <div class="CustomDropdownResult" *ngFor="let a of Company.Addresses" (click)="newAgentAddress = a; newAgent.controls['Address'].setValue(a); openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{a.Country.Name}} {{a.StateProvince}} {{a.City}} {{a.AddressLine}}</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="ModernFormGroup" *ngIf="this.currentAgent?.ID > 0;">
                <label class="ModernFormLabel">{{ 'Department' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'agentDepartment'" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('agentDepartment')">
                    <i class="material-icons dropdown-icon-left">badge</i>
                    <input type="text" class="CustomDropdownInput" [value]="currentAgent.Department?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="openDropdownId === 'agentDepartment'">
                    <div class="CustomDropdownResult" *ngFor="let d of this.AccountingMasterData.Departments" (click)="currentAgent.Department = d; newAgent.controls['Department'].setValue(d); openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{d.Name}}</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="PopUpBodySemiTextBox FileChosingContainer" *ngIf="this.currentAgent != null;">
              <form [formGroup]="newBlogForm" (ngSubmit)="AddAgentSignature(newBlogForm.value)">
                <div style="margin-bottom: 15px;">
                    <input type="file" class="ModernFileInput" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                </div>
                <button type="submit" class="ModernButton outline"><i class="material-icons">upload</i> {{ 'UploadSignature' | translate }}</button>
              </form>
            </div>

            <div class="PopUpBodySemiTextBox FileChosingContainer" *ngIf="this.currentAgent?.Signature != null;">
              <p class="signatureTitle">{{ 'Signature' | translate }}:</p>
              <img [src]="this.parent.BackendServiceUrl + this.currentAgent?.Signature" class="signatureImage" />
            </div>
    
            <div class="ModernPopupGrid">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Configuration.FullName' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">person</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" formControlName="Name">
                </div>
              </div>

              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Login.Phone' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">phone</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" formControlName="Phone">
                </div>
              </div>

              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Login.Email' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">email</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" formControlName="Email">
                </div>
              </div>

              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Configuration.Function' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">work</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" formControlName="Function">
                </div>
              </div>
            </div>
        
          </form>
  
        </div>
  
        <div class="ModernPopupFooter">
          <button class="ModernPopupButton secondary" (click)="showAddNewAgentPopUp = false;">
            <i class="material-icons">close</i>
            <span>{{ 'Cancel' | translate }}</span>
          </button>
          <button (click)="this.AddUpdateAgent();" [disabled]="parent.loading" matTooltip="Submit Partner" class="ModernPopupButton primary">
            <i class="material-icons">person_add</i>
            <span>{{ 'Configuration.AddAgent' | translate }}</span>
          </button>
        </div>
       </div>
      </div>

      <div class="ModernPopupOverlay" *ngIf="ShowDeleteBankAccountQuestion" (click)="ShowDeleteBankAccountQuestion = false;">
       <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons">delete</i>
            <span>{{ 'Configuration.DeleteBankAccountQuestion' | translate }}</span>
          </div>
          <button class="ModernPopupClose" (click)="ShowDeleteBankAccountQuestion = false;">
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="ModernPopupBody">
          {{ 'Configuration.DeleteBankAccountQuestionDescription' | translate }}
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernPopupButton secondary" (click)="ShowDeleteBankAccountQuestion = false;">
            <i class="material-icons">close</i>
            <span>{{ 'Configuration.DeleteNoButton' | translate }}</span>
          </button>
          <button class="ModernPopupButton danger" (click)="DeleteCompanyBankAccount();">
            <i class="material-icons">delete</i>
            <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
          </button>
        </div>
       </div>
      </div>

      <div class="ModernPopupOverlay" *ngIf="ShowDeleteAdministrationQuestion" (click)="ShowDeleteAdministrationQuestion = false;">
       <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons">delete</i>
            <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
          </div>
          <button class="ModernPopupClose" (click)="ShowDeleteAdministrationQuestion = false;">
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="ModernPopupBody">
          {{ 'Configuration.DeleteQuestionDescription' | translate }}
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernPopupButton secondary" (click)="ShowDeleteAdministrationQuestion = false;">
            <i class="material-icons">close</i>
            <span>{{ 'Configuration.DeleteNoButton' | translate }}</span>
          </button>
          <button class="ModernPopupButton danger" (click)="DeleteCompanyAdministration();">
            <i class="material-icons">delete</i>
            <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
          </button>
        </div>
       </div>
      </div>

      <!-- Shipping Address Popup -->
      <div class="ModernPopupOverlay" *ngIf="ShowShippingAddressPopup" (click)="ShowShippingAddressPopup = false;">
       <div class="ModernPopup large" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons">local_shipping</i>
            <span *ngIf="EditingShippingAddress?.ID == 0">{{ 'Partners.AddNewShippingAddress' | translate }}</span>
            <span *ngIf="EditingShippingAddress?.ID != 0">{{ 'Partners.EditShippingAddress' | translate }}</span>
          </div>
          <button class="ModernPopupClose" (click)="ShowShippingAddressPopup = false;">
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="ModernPopupBody" *ngIf="EditingShippingAddress != null;">
          <div class="ModernPopupGrid">
            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'Partners.ContactPerson' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">person</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.ContactPerson">
              </div>
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'Partners.ContactCompany' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">business</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.ContactCompany">
              </div>
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'Partners.VAT' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">badge</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.VATNumber">
              </div>
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'Country' | translate }}</label>
              <div class="CustomDropdownContainer">
                <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'shipCountry'" (click)="openDropdownId = null"></div>
                <div class="CustomDropdownBar" (click)="toggleDropdown('shipCountry')">
                  <i class="material-icons dropdown-icon-left">public</i>
                  <input type="text" class="CustomDropdownInput" [value]="EditingShippingAddress.Country?.Name || ''" readonly />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="openDropdownId === 'shipCountry'">
                  <div class="CustomDropdownResult" *ngFor="let c of this.parent.masterData?.Countries" (click)="SelectShippingAddressCountry(c); openDropdownId = null;">
                    <div class="CustomDropdownResultMain">
                      <span class="CustomDropdownResultText">{{c.Name}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'Partners.StateProvince' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">map</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.State">
              </div>
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'Partners.City' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">location_city</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.City">
              </div>
            </div>

            <div class="ModernFormGroup ModernFormGroupFull">
              <label class="ModernFormLabel">{{ 'Partners.AddressLine' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">home</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.AddressLine">
              </div>
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'ZipCode' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">markunread_mailbox</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.ZipCode">
              </div>
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'Email' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">email</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.Email">
              </div>
            </div>

            <div class="ModernFormGroup">
              <label class="ModernFormLabel">{{ 'Phone' | translate }}</label>
              <div class="PartnerSearchBar">
                <i class="material-icons search-icon">phone</i>
                <input type="text" class="PartnerSearchInput" [(ngModel)]="EditingShippingAddress.Phone">
              </div>
            </div>

            <div class="ModernFormGroup ModernFormGroupFull" style="flex-direction: row; gap: 30px; margin-top: 4px;">
              <div class="auto-save-toggle-container">
                <label class="auto-save-toggle">
                  <input type="checkbox" [(ngModel)]="EditingShippingAddress.ActiveAddress">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label">{{ 'Partners.ActiveAddress' | translate }}</span>
              </div>
              <div class="auto-save-toggle-container">
                <label class="auto-save-toggle">
                  <input type="checkbox" [(ngModel)]="EditingShippingAddress.IsSelected">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label">{{ 'Partners.MainAddress' | translate }}</span>
              </div>
            </div>
          </div>

        </div>

        <div class="ModernPopupFooter" *ngIf="EditingShippingAddress != null;">
          <button class="ModernPopupButton secondary" (click)="ShowShippingAddressPopup = false;">
            <i class="material-icons">close</i>
            <span>{{ 'Cancel' | translate }}</span>
          </button>
          <button class="ModernPopupButton primary" (click)="SaveShippingAddress();">
            <i class="material-icons">save_alt</i>
            <span>{{ 'Partners.SaveAddress' | translate }}</span>
          </button>
        </div>
       </div>
      </div>

      <!-- Delete Shipping Address Confirmation -->
      <div class="ModernPopupOverlay" *ngIf="ShowDeleteShippingAddressQuestion" (click)="ShowDeleteShippingAddressQuestion = false;">
       <div class="ModernPopup small" (click)="$event.stopPropagation()">
        <div class="ModernPopupHeader">
          <div class="ModernPopupTitle">
            <i class="material-icons">delete</i>
            <span>{{ 'Configuration.DeleteQuestion' | translate }}</span>
          </div>
          <button class="ModernPopupClose" (click)="ShowDeleteShippingAddressQuestion = false;">
            <i class="material-icons">close</i>
          </button>
        </div>
        <div class="ModernPopupBody">
          {{ 'Configuration.DeleteQuestionDescription' | translate }}
        </div>
        <div class="ModernPopupFooter">
          <button class="ModernPopupButton secondary" (click)="ShowDeleteShippingAddressQuestion = false;">
            <i class="material-icons">close</i>
            <span>{{ 'Configuration.DeleteNoButton' | translate }}</span>
          </button>
          <button class="ModernPopupButton danger" (click)="DeleteShippingAddress();">
            <i class="material-icons">delete</i>
            <span>{{ 'Configuration.DeleteYesButton' | translate }}</span>
          </button>
        </div>
       </div>
      </div>

    <div class="profile-container">
      <div class="profile-card">

        <!-- Tab Navigation -->
        <div class="self-service-tabs">
          <button class="self-service-tab" [class.active]="activeTab == 0" (click)="selectTab(0);">
            <i class="material-icons">business</i>
            <span>{{ 'Configuration.CompanyData' | translate }}</span>
          </button>
          <button class="self-service-tab" [class.active]="activeTab == 1" (click)="selectTab(1);">
            <i class="material-icons">account_balance</i>
            <span>{{ 'BankAccounts' | translate }}</span>
          </button>
          <button class="self-service-tab" [class.active]="activeTab == 2" (click)="selectTab(2);">
            <i class="material-icons">format_list_numbered</i>
            <span>{{ 'DocumentSeries' | translate }}</span>
          </button>
          <button class="self-service-tab" [class.active]="activeTab == 3" (click)="selectTab(3);">
            <i class="material-icons">admin_panel_settings</i>
            <span>{{ 'Administrations' | translate }}</span>
          </button>
          <button class="self-service-tab" [class.active]="activeTab == 4" (click)="selectTab(4);">
            <i class="material-icons">people</i>
            <span>{{ 'Dashboard.Menu.Partners' | translate }}</span>
          </button>
          <button class="self-service-tab" [class.active]="activeTab == 5" (click)="selectTab(5);">
            <i class="material-icons">print</i>
            <span>{{ 'AutoPrintSettings' | translate }}</span>
          </button>
          <button class="self-service-tab" [class.active]="activeTab == 6" (click)="selectTab(6);">
            <i class="material-icons">delete_sweep</i>
            <span>{{ 'DeleteDataSettings' | translate }}</span>
          </button>
          <button class="self-service-tab" [class.active]="activeTab == 7" (click)="selectTab(7);">
            <i class="material-icons">receipt_long</i>
            <span>{{ 'EFacturaSettings' | translate }}</span>
          </button>
        </div>

        <div class="card-content">

        <!-- ========== TAB 0: COMPANY DATA ========== -->
        <div *ngIf="activeTab == 0">
          <div class="loading-container" *ngIf="loading">
            <div class="modern-spinner"></div>
          </div>

            <div class="MainTabBody" *ngIf="!loading">

                <div class="ModernPopupGrid">
                  <div class="ModernFormGroup">
                    <label class="ModernFormLabel">{{ 'Partners.VAT' | translate }}</label>
                    <div class="PartnerSearchBar">
                      <i class="material-icons search-icon">badge</i>
                      <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="this.Company.VATNumber">
                    </div>
                  </div>

                  <div class="ModernFormGroup">
                    <label class="ModernFormLabel">{{ 'Partners.Name' | translate }}</label>
                    <div class="PartnerSearchBar">
                      <i class="material-icons search-icon">business</i>
                      <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="this.Company.Name">
                    </div>
                  </div>

                  <div class="ModernFormGroup">
                    <label class="ModernFormLabel">{{ 'Partners.COCRegNumber' | translate }}</label>
                    <div class="PartnerSearchBar">
                      <i class="material-icons search-icon">tag</i>
                      <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="this.Company.COCRegisterNr">
                    </div>
                  </div>

                  <div class="ModernFormGroup">
                    <label class="ModernFormLabel">{{ 'Partners.Alias' | translate }}</label>
                    <div class="PartnerSearchBar">
                      <i class="material-icons search-icon">label</i>
                      <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="this.Company.Alias">
                    </div>
                  </div>

                  <div class="ModernFormGroup">
                    <label class="ModernFormLabel">{{ 'AccountSettingsPage.UserCompanyRoles' | translate }}</label>
                    <div class="PartnerSearchBar disabled">
                      <i class="material-icons search-icon">verified_user</i>
                      <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.parent.Company.MainRole.Meaning">
                    </div>
                  </div>
                </div>

                  <div class="fullWidthContainer" style="margin-bottom: 2%;">

                    <div class="halfWidth">
                      <button class="ModernButton primary" (click)="UpdateCompanyData();"><i class="material-icons">save_alt</i> {{ 'Configuration.UpdateCompany' | translate }}</button>
                    </div>
                  </div>

                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'UXDetails' | translate }}:</p>
                  </div>

                  <div class="fullWidthContainer" style="padding-left: 3px; padding-right: 3px;" *ngIf="Company.UXDetails?.ShowPartnerFinancialData != null;">
                      <div class="auto-save-toggle-container">
                        <label class="auto-save-toggle">
                          <input #uxToggle type="checkbox" [(ngModel)]="Company.UXDetails.ShowPartnerFinancialData" (change)="AddUpdateCompanyUXDetails({checked: uxToggle.checked})">
                          <span class="toggle-slider"></span>
                        </label>
                        <span class="auto-save-label">{{ 'ShowPartnerFinancialData' | translate }}</span>
                      </div>
                  </div>

                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'Configuration.CompanyAddresses' | translate }}:</p>
                  </div>

                  <div class="fullWidthContainer" style="padding-left: 3px; padding-right: 3px;">
                    <div class="ModernAccordion">

                        <div class="ModernAccordionHeader is-static">
                          <span class="ModernAccordionTitle">{{ 'Country' | translate }}</span>
                          <span class="ModernAccordionDesc">{{ 'Partners.PartnerWindow.StateProvince' | translate }}</span>
                          <span class="ModernAccordionDesc">{{ 'Partners.PartnerWindow.City' | translate }}</span>
                        </div>

                        <div class="ModernAccordionItem" [class.open]="openAddressIndex === i" *ngFor="let a of this.Company.Addresses; index as i">
                          <div class="ModernAccordionHeader" (click)="openAddressIndex = openAddressIndex === i ? -1 : i">
                            <span class="ModernAccordionTitle">{{a.Country.Name}}</span>
                            <span class="ModernAccordionDesc">{{a.StateProvince}}</span>
                            <span class="ModernAccordionDesc">{{a.City}}</span>
                            <i class="material-icons ModernAccordionChevron">expand_more</i>
                          </div>

                          <div class="ModernAccordionBody" *ngIf="openAddressIndex === i && !loading" style="margin-top: 20px;">
                
                            <div class="ModernPopupGrid">
                              <div class="ModernFormGroup ModernFormGroupFull">
                                <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</label>
                                <div class="CustomDropdownContainer">
                                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'addrCountry' + i" (click)="openDropdownId = null"></div>
                                  <div class="CustomDropdownBar" (click)="toggleDropdown('addrCountry' + i)">
                                    <i class="material-icons dropdown-icon-left">public</i>
                                    <input type="text" class="CustomDropdownInput" [value]="a.Country?.Name || ''" readonly />
                                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                                  </div>
                                  <div class="CustomDropdownResults" *ngIf="openDropdownId === 'addrCountry' + i">
                                    <div class="CustomDropdownResult" *ngFor="let c of parent.masterData.Countries" (click)="a.Country = c; openDropdownId = null;">
                                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{c.Name}}</span></div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="ModernFormGroup">
                                <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.StateProvince' | translate }}</label>
                                <div class="PartnerSearchBar">
                                  <i class="material-icons search-icon">map</i>
                                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="a.StateProvince">
                                </div>
                              </div>

                              <div class="ModernFormGroup">
                                <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.City' | translate }}</label>
                                <div class="PartnerSearchBar">
                                  <i class="material-icons search-icon">location_city</i>
                                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="a.City">
                                </div>
                              </div>

                              <div class="ModernFormGroup">
                                <label class="ModernFormLabel">{{ 'Partners.PartnerWindow.AddressLine' | translate }}</label>
                                <div class="PartnerSearchBar">
                                  <i class="material-icons search-icon">home</i>
                                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="a.AddressLine">
                                </div>
                              </div>

                              <div class="ModernFormGroup ModernFormGroupFull">
                                <label class="ModernFormLabel">{{ 'ZipCode' | translate }}</label>
                                <div class="PartnerSearchBar">
                                  <i class="material-icons search-icon">markunread_mailbox</i>
                                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="a.ZipCode">
                                </div>
                              </div>
                            </div>

    
                              <button class="ModernButton primary" (click)="UpdateAddress(a);"><i class="material-icons">save_alt</i> {{ 'Configuration.UpdateAddress' | translate }}</button>
                              <button style="margin-left: 10px;" class="ModernButton outline-danger" (click)="DeleteCompanyAddress(a.ID);"><i class="material-icons">close</i> {{ 'Configuration.DeleteAddress' | translate }}</button>
                            </div>

                        </div>
                      </div>
                  </div>

                  <div class="halfWidth" style="margin-top: 2%;padding-left: 3px;">
                    <button class="ModernFab primary" (click)="initializeAddAddressForm();showAddNewAddressPopUp = true;">
                        <i class="material-icons">add_location_alt</i>
                    </button>
                  </div>
                  
                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'Configuration.CompanyAgents' | translate }}:</p>
                  </div>

                  <div class="fullWidthContainer" style="margin-top: 2%;padding-left: 3px;">
                    <button class="ModernFab primary" (click)="currentAgent = null; initializeAddAgentForm(); showAddNewAgentPopUp = true;">
                        <i class="material-icons">group_add</i>
                    </button>
                  </div>

                  <div class="fullWidthContainer">
                    <div class="halfWidth">
                      <div class="ModernAgentList">
                        <div class="ModernAgentRow" *ngFor="let a of this.Company.Agents">
                          <span class="ModernAgentName">{{a.Name}}</span>
                          <div class="ModernAgentActions">
                            <i class="material-icons agentSettings" (click)="this.currentAgent = a;initializeAddAgentForm(); showAddNewAgentPopUp = true;">edit</i>
                            <i class="material-icons agentDelete" (click)="DeleteAgent(a.ID);">close</i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'EmailServers' | translate }}:</p>

                    <div class="fullWidthContainer" *ngIf="NewSMTP == null;" style="margin-bottom: 20px;">
                      <button class="ModernButton accent" (click)="InitializeNewSMTP();"><i class="material-icons">add</i> {{'AddNew' | translate}}</button>
                    </div>

                    <div style="margin-top: 20px;" *ngIf="NewSMTP != null;">
                      <div class="ModernPopupGrid">
                        <div class="ModernFormGroup">
                          <label class="ModernFormLabel">{{ 'SMTP' | translate }}</label>
                          <div class="PartnerSearchBar">
                            <i class="material-icons search-icon">dns</i>
                            <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="NewSMTP.SMTPServer">
                          </div>
                        </div>

                        <div class="ModernFormGroup">
                          <label class="ModernFormLabel">{{ 'Port' | translate }}</label>
                          <div class="PartnerSearchBar">
                            <i class="material-icons search-icon">settings_ethernet</i>
                            <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="NewSMTP.Port">
                          </div>
                        </div>
                      </div>

                      <div class="halfWidth">
                        <button (click)="AddUpdateSMTPServerConfig(NewSMTP);" class="ModernButton primary ExpansionSaveListButton">{{'Configuration.SaveChanges' | translate}}</button>
                        <button (click)="NewSMTP = null;" class="ModernButton danger ExpansionSaveListButton" style="margin-right: 10px;">{{'Delete' | translate}}</button>
                      </div>
                    </div>
                  </div>

                  <div class="fullWidthContainer" style="padding-left: 3px; padding-right: 3px;margin-bottom: 5%;">
                    <div class="ModernAccordion">

                        <div class="ModernAccordionHeader is-static">
                          <span class="ModernAccordionTitle">{{ 'SMTP' | translate }}</span>
                          <span class="ModernAccordionDesc"></span>
                          <span class="ModernAccordionDesc">{{ 'Port' | translate }}</span>
                        </div>

                        <div class="ModernAccordionItem" [class.open]="openSmtpIndex === i" *ngFor="let s of this.SMTPConfigs; index as i">
                          <div class="ModernAccordionHeader" (click)="toggleSmtpPanel(i, s)">
                            <span class="ModernAccordionTitle">{{s.SMTPServer}}</span>
                            <span class="ModernAccordionDesc"></span>
                            <span class="ModernAccordionDesc">{{s.Port}}</span>
                            <i class="material-icons ModernAccordionChevron">expand_more</i>
                          </div>

                          <div class="ModernAccordionBody" *ngIf="openSmtpIndex === i">
                          <div style="margin-top: 20px;">
                            <div class="ModernPopupGrid">
                              <div class="ModernFormGroup">
                                <label class="ModernFormLabel">{{ 'SMTP' | translate }}</label>
                                <div class="PartnerSearchBar">
                                  <i class="material-icons search-icon">dns</i>
                                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="s.SMTPServer">
                                </div>
                              </div>

                              <div class="ModernFormGroup">
                                <label class="ModernFormLabel">{{ 'Port' | translate }}</label>
                                <div class="PartnerSearchBar">
                                  <i class="material-icons search-icon">settings_ethernet</i>
                                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="s.Port">
                                </div>
                              </div>
                            </div>

                            <div class="halfWidth">
                              <button (click)="AddUpdateSMTPServerConfig(s);" class="ModernButton primary ExpansionSaveListButton">{{'Configuration.SaveChanges' | translate}}</button>
                              <button (click)="ShowDeleteSMTPQuestion = true;" class="ModernButton danger ExpansionSaveListButton" style="margin-right: 10px;">{{'Delete' | translate}}</button>
                            </div>
                          </div>

                          <div class="fullWidthContainer">
                            <p class="ExpandTabTitle">{{ 'EmailAddresses' | translate }}:</p>
                          </div>

                          <div *ngIf="!loadingUser" style="margin-top: 2%;">
                            <div class="fullWidthContainer" *ngFor="let e of this.SMTPEmails; index as j">
                             <div class="ModernPopupGrid">

                              <div class="ModernFormGroup">
                                <label class="ModernFormLabel">{{ 'Email' | translate }}</label>
                                <div class="PartnerSearchBar">
                                  <i class="material-icons search-icon">email</i>
                                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="e.Email">
                                </div>
                              </div>

                              <div class="ModernFormGroup">
                                <label class="ModernFormLabel">{{ 'Password' | translate }}</label>
                                <div class="PartnerSearchBar">
                                  <i class="material-icons search-icon">lock</i>
                                  <input class="PartnerSearchInput" [(ngModel)]="e.Password" [type]="e.HidePassword ? 'password' : 'text'">
                                  <i class="material-icons search-icon" style="cursor: pointer;" (click)="e.HidePassword = !e.HidePassword">{{e.HidePassword ? 'visibility_off' : 'visibility'}}</i>
                                </div>
                              </div>

                             </div>

                             <div class="fullWidthContainer" style="display: flex; align-items: center; gap: 12px; margin-top: 10px;">
                              <div class="auto-save-toggle-container">
                                <label class="auto-save-toggle">
                                  <input type="checkbox" [(ngModel)]="e.IsDefault">
                                  <span class="toggle-slider"></span>
                                </label>
                                <span class="auto-save-label">{{'DefaultAddress' | translate}}</span>
                              </div>
                              <button (click)="AddUpdateCompanySMTPEmail(e);" class="ModernButton primary ExpansionSaveListButton">{{'Configuration.SaveChanges' | translate}}</button>
                              <button (click)="CurrenctSMTPEmail = e; ShowDeleteSMTPEmailQuestion = true;" class="ModernButton danger ExpansionSaveListButton" style="margin-right: 10px;">{{'Delete' | translate}}</button>
                            </div>

                            </div>

                            <div class="fullWidthContainer">
                              <button *ngIf="NewSMTPEmail == null;" class="ModernButton accent" (click)="InitializeNewSMTPEmail();"><i class="material-icons">add</i> {{'AddNew' | translate}}</button>
                            </div>

                            <div class="fullWidthContainer" *ngIf="NewSMTPEmail != null;">
                              <div class="ModernPopupGrid">

                               <div class="ModernFormGroup">
                                 <label class="ModernFormLabel">{{ 'Email' | translate }}</label>
                                 <div class="PartnerSearchBar">
                                   <i class="material-icons search-icon">email</i>
                                   <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="NewSMTPEmail.Email">
                                 </div>
                               </div>

                               <div class="ModernFormGroup">
                                 <label class="ModernFormLabel">{{ 'Password' | translate }}</label>
                                 <div class="PartnerSearchBar">
                                   <i class="material-icons search-icon">lock</i>
                                   <input class="PartnerSearchInput" [(ngModel)]="NewSMTPEmail.Password" [type]="NewSMTPEmail.HidePassword ? 'password' : 'text'">
                                   <i class="material-icons search-icon" style="cursor: pointer;" (click)="NewSMTPEmail.HidePassword = !NewSMTPEmail.HidePassword">{{NewSMTPEmail.HidePassword ? 'visibility_off' : 'visibility'}}</i>
                                 </div>
                               </div>

                              </div>

                              <div class="fullWidthContainer" style="display: flex; align-items: center; gap: 12px; margin-top: 10px;">
                               <div class="auto-save-toggle-container">
                                 <label class="auto-save-toggle">
                                   <input type="checkbox" [(ngModel)]="NewSMTPEmail.IsDefault">
                                   <span class="toggle-slider"></span>
                                 </label>
                                 <span class="auto-save-label">{{'DefaultAddress' | translate}}</span>
                               </div>
                               <button (click)="AddUpdateCompanySMTPEmail(NewSMTPEmail);" class="ModernButton primary ExpansionSaveListButton">{{'Configuration.SaveChanges' | translate}}</button>
                               <button (click)="NewSMTPEmail = null;" class="ModernButton danger ExpansionSaveListButton" style="margin-right: 10px;">{{'Delete' | translate}}</button>
                             </div>

                             </div>

                          </div>

                           <div class="fullWidthContainer" *ngIf="loadingUser">
                            <div class="modern-spinner"></div>
                          </div>

                          </div>
                        </div>
                      </div>
                  </div>

                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'CompanyLogo' | translate }}</p>
                  </div>

                  <div class="fullWidthContainer" *ngIf="this.Company?.LogoPath?.length > 0;">
                    <img [src]="this.parent.BackendServiceUrl + this.Company?.LogoPath" class="signatureImage" />
                  </div>

                  <div class="fullWidthContainer">
                    <form [formGroup]="newCompanyLogo" (ngSubmit)="AddUpdateCompanyLogo()">
                      <div style="margin-bottom: 15px;">
                          <input type="file" class="ModernFileInput" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                      </div>
                      <button type="submit" class="ModernButton outline"><i class="material-icons">upload</i> {{ 'UploadLogo' | translate }}</button>
                    </form>
                  </div>

                  <!-- Company Shipping Addresses -->
                  <div class="fullWidthContainer">
                    <p class="ExpandTabTitle">{{ 'Partners.ShippingAddresses' | translate }}:</p>
                  </div>

                  <div class="fullWidthContainer" style="margin-top: 2%;padding-left: 3px;">
                    <button class="ModernButton primary" (click)="OpenNewShippingAddress();">
                      <i class="material-icons">add_location_alt</i> {{ 'Partners.AddNewShippingAddress' | translate }}
                    </button>
                  </div>

                  <div class="fullWidthContainer" *ngIf="CompanyShippingAddresses?.length > 0" style="padding-left: 3px; padding-right: 3px;">
                    <div *ngFor="let addr of CompanyShippingAddresses; index as i" class="SeriesRow" style="display: flex; align-items: center; justify-content: space-between;" [style.border-left]="addr.IsSelected ? '3px solid #1976d2' : '3px solid transparent'">
                      <div style="flex: 1; cursor: pointer;" (click)="EditShippingAddress(addr);">
                        <div style="font-weight: 600; font-size: 13px;">
                          <i class="material-icons" *ngIf="addr.IsSelected" style="font-size: 14px; color: #1976d2; vertical-align: middle; margin-right: 4px;">check_circle</i>
                          <span>{{addr.ContactCompany}}</span>
                          <span *ngIf="addr.ContactPerson" style="color: #666; margin-left: 6px;">- {{addr.ContactPerson}}</span>
                        </div>
                        <div style="font-size: 12px; color: #555; margin-top: 2px;">
                          <span *ngIf="addr.Country?.Name">{{addr.Country?.Name}}, </span>
                          <span *ngIf="addr.City">{{addr.City}}, </span>
                          <span *ngIf="addr.AddressLine">{{addr.AddressLine}}</span>
                          <span *ngIf="addr.ZipCode"> - {{addr.ZipCode}}</span>
                        </div>
                        <div style="font-size: 11px; color: #888; margin-top: 2px;">
                          <span *ngIf="addr.Email">{{addr.Email}}</span>
                          <span *ngIf="addr.Email && addr.Phone"> | </span>
                          <span *ngIf="addr.Phone">{{addr.Phone}}</span>
                        </div>
                      </div>
                      <div style="flex-shrink: 0; padding-left: 10px;">
                        <i class="material-icons ReceptionProductEdit" style="cursor:pointer; color: #e53935;" (click)="AskDeleteShippingAddress(addr);">close</i>
                      </div>
                    </div>
                  </div>

                  <div class="fullWidthContainer" *ngIf="CompanyShippingAddresses?.length == 0" style="padding: 10px 3px; color: #999; font-size: 13px;">
                    {{ 'Partners.NoShippingAddresses' | translate }}
                  </div>

            </div>
        </div>

        <!-- ========== TAB 1: BANK ACCOUNTS ========== -->
        <div *ngIf="activeTab == 1">
          <div class="loading-container" *ngIf="loading">
            <div class="modern-spinner"></div>
          </div>

          <div class="MainTabBody">
            <p class="MainTabBodyTitle">{{'AddNewBank' |  translate}}</p>

            <div class="ModernPopupGrid">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'BankName' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">account_balance</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="NewBank.Name">
                </div>
              </div>

              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'Swift' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">code</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="NewBank.Swift">
                </div>
              </div>
            </div>
            <button class="ModernButton primary" (click)="AddBank(NewBank);"><i class="material-icons">save_alt</i> {{ 'AddNewBank' | translate }}</button>
          </div>

          <div class="MainTabBody" *ngIf="!loading">
            <div class="BankAccountRow" *ngFor="let b of this.Company.Banks; index as i">
             <div *ngFor="let a of b.BankAccounts; index as j" class="fullWidthContainer">
              <div class="thirdContainer" style="width: auto;">
                <i class="material-icons ReceptionProductEdit" (click)="AskDeleteBankAccountQuestion(a);">close</i>
              </div>

              <div class="thirdContainer">
                <label class="ModernFormLabel">{{ 'Bank' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'bankAcct' + i + '_' + j" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('bankAcct' + i + '_' + j)">
                    <i class="material-icons dropdown-icon-left">account_balance</i>
                    <input type="text" class="CustomDropdownInput" [value]="getDisplayBankName(a.BankID)" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="openDropdownId === 'bankAcct' + i + '_' + j">
                    <div class="CustomDropdownResult" *ngFor="let bk of parent.masterData.Banks" (click)="a.BankID = bk; openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{bk.Name}}</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="thirdContainer">
                <label class="ModernFormLabel">{{ 'Currency' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'bankCurr' + i + '_' + j" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('bankCurr' + i + '_' + j)">
                    <i class="material-icons dropdown-icon-left">payments</i>
                    <input type="text" class="CustomDropdownInput" [value]="a.Currency?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="openDropdownId === 'bankCurr' + i + '_' + j">
                    <div class="CustomDropdownResult" *ngFor="let c of parent.masterData.Currencies" (click)="a.Currency = c; openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{c.Name}}</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="thirdContainer" style="width: 25%;">
                <label class="ModernFormLabel">{{ 'AccountNumber' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">pin</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="a.AccountNumber">
                </div>
              </div>

              <div class="thirdContainer" style="width: 15%;height: 61.8px;padding-top: 8px;">
                <div class="auto-save-toggle-container">
                  <label class="auto-save-toggle">
                    <input type="checkbox" [(ngModel)]="a.IsActive">
                    <span class="toggle-slider"></span>
                  </label>
                  <span class="auto-save-label">{{'IsActive' | translate}}</span>
                </div>
              </div>

              <div class="thirdContainer" style="width: 15%;">
                <label class="ModernFormLabel">{{'OrderRank' | translate}}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">sort</i>
                  <input type="number" class="PartnerSearchInput" [(ngModel)]="a.OrderRank" min="0" max="100" step="1">
                </div>
              </div>
             </div>
            </div>

            <div class="thirdContainer">
              <button class="ModernFab primary" (click)="initializeNewBankAccount();">
                <i class="material-icons">add</i>
              </button>
            </div>

            <div class="fullWidthContainer" *ngIf="newBankAccount != null;">

              <div class="thirdContainer" style="width: auto;">
                <i class="material-icons ReceptionProductEdit" (click)="newBankAccount = null;">close</i>
              </div>

              <div class="thirdContainer">
                <label class="ModernFormLabel">{{ 'Bank' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'newBankBank'" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('newBankBank')">
                    <i class="material-icons dropdown-icon-left">account_balance</i>
                    <input type="text" class="CustomDropdownInput" [value]="newBankAccount.Bank?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="openDropdownId === 'newBankBank'">
                    <div class="CustomDropdownResult" *ngFor="let bk of parent.masterData.Banks" (click)="newBankAccount.Bank = bk; openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{bk.Name}}</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="thirdContainer">
                <label class="ModernFormLabel">{{ 'Currency' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'newBankCurr'" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('newBankCurr')">
                    <i class="material-icons dropdown-icon-left">payments</i>
                    <input type="text" class="CustomDropdownInput" [value]="newBankAccount.Currency?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults CustomDropdownResultsUpward" *ngIf="openDropdownId === 'newBankCurr'">
                    <div class="CustomDropdownResult" *ngFor="let c of parent.masterData.Currencies" (click)="newBankAccount.Currency = c; openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{c.Name}}</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="thirdContainer" style="width: 32%;">
                <label class="ModernFormLabel">{{ 'AccountNumber' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">pin</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="newBankAccount.AccountNumber">
                </div>
              </div>

              <div class="thirdContainer">
                <button class="ModernFab primary" (click)="AddCompanyBankAccount();">
                  <i class="material-icons">save_alt</i>
                </button>
              </div>
            </div>

            <div class="fullWidthContainer">
              <button class="ModernButton primary" (click)="UpdateCompanyBankAccountsBulk();"><i class="material-icons">save_alt</i> {{ 'Configuration.SaveChanges' | translate }}</button>
            </div>

          </div>

        </div>

        <!-- ========== TAB 2: DOCUMENT SERIES ========== -->
        <div *ngIf="activeTab == 2">
          <div class="loading-container" *ngIf="loading">
            <div class="modern-spinner"></div>
          </div>

          <div class="MainTabBody" *ngIf="!loading">

            <div class="SeriesRow" *ngFor="let s of this.Company.AccountingSeries; index as i">

              <div class="fullWidthContainer">
                <div class="thirdContainer" style="width: auto;padding-top: 24px;">
                  <div class="auto-save-toggle-container">
                    <label class="auto-save-toggle">
                      <input #sActive type="checkbox" [(ngModel)]="s.IsActive" (change)="s.IsActive = sActive.checked; UpdateAccountingSeriesActiveFlag(s);">
                      <span class="toggle-slider"></span>
                    </label>
                    <span class="auto-save-label">{{ 'IsActive' | translate }}</span>
                  </div>
                </div>

                <div class="thirdContainer">
                  <label class="ModernFormLabel">{{ 'DocumentType' | translate }}</label>
                  <div class="CustomDropdownContainer">
                    <div class="CustomDropdownBar disabled">
                      <i class="material-icons dropdown-icon-left">description</i>
                      <input type="text" class="CustomDropdownInput" [value]="s.GeneralDocTypeObject?.Name || ''" readonly disabled />
                      <i class="material-icons dropdown-icon">arrow_drop_down</i>
                    </div>
                  </div>
                </div>

                <div class="thirdContainer" style="width: 10%;">
                  <label class="ModernFormLabel">{{ 'Series' | translate }}</label>
                  <div class="PartnerSearchBar">
                    <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="s.Series">
                  </div>
                </div>

                <div class="thirdContainer" style="width: 10%;">
                  <label class="ModernFormLabel">{{ 'HighestValue' | translate }}</label>
                  <div class="PartnerSearchBar disabled">
                    <input type="text" class="PartnerSearchInput" [(ngModel)]="s.HighestValue" disabled>
                  </div>
                </div>

                <div class="thirdContainer" style="width: 10%;">
                  <label class="ModernFormLabel">{{ 'StartIndex' | translate }}</label>
                  <div class="PartnerSearchBar">
                    <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="s.StartIndex">
                  </div>
                </div>
  
                <div class="thirdContainer">
                  <button *ngIf="s.DeletePossibility == true;" class="ModernFab danger" (click)="DeleteAccountingSeries(s.ID);">
                    <i class="material-icons">close</i>
                  </button>
                </div>

              </div>
              <div class="fullWidthContainer">
                  <form [formGroup]="newBlogForm" (ngSubmit)="AddSeriesLogo(s.ID)" style="width: auto;float: left;">
                    <div style="margin-bottom: 10px;">
                        <input type="file" class="ModernFileInput" formControlName="UploadedFile" (change)="onSelectFile($event)" >
                    </div>

                    <button type="submit" class="ModernButton outline"><i class="material-icons">upload</i> {{ 'UploadLogo' | translate }}</button>
                  </form>

                  <div class="thirdContainer" *ngIf="s.LogoPath != null;">
                    <img [src]="this.parent.BackendServiceUrl + s.LogoPath" class="signatureImage" />
                  </div>

                  <div class="fullWidthContainer" style="margin-top: 20px;">
                   <div class="thirdContainer">
                    <label class="ModernFormLabel">{{ 'ColorHash' | translate }}</label>
                    <div class="PartnerSearchBar">
                      <i class="material-icons search-icon">palette</i>
                      <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="s.ColorHash">
                    </div>
                   </div>

                   <div class="ColorHashChoiceContainer">
                      <div class="ColorHashChoice" style="background: #254a91;" (click)="s.ColorHash = '#254a91'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#254a91'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #00aeef;" (click)="s.ColorHash = '#00aeef'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#00aeef'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #2CA70F;" (click)="s.ColorHash = '#2CA70F'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#2CA70F'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #f60;" (click)="s.ColorHash = '#f60'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#f60'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #0082e6;" (click)="s.ColorHash = '#0082e6'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#0082e6'">check</i>
                      </div>

                      <div class="ColorHashChoice" style="background: #5b2281;" (click)="s.ColorHash = '#5b2281'">
                        <i class="material-icons ColorHashChoiceIcon" *ngIf="s.ColorHash == '#5b2281'">check</i>
                      </div>
                  </div>
                  </div>

                  <div class="fullWidthContainer" style="margin-bottom: 20px;">
                    <div class="auto-save-toggle-container">
                      <label class="auto-save-toggle">
                        <input type="checkbox" [(ngModel)]="s.GenerateQRCodeOnDocuments">
                        <span class="toggle-slider"></span>
                      </label>
                      <span class="auto-save-label">{{'GenerateQRCodeOnDocuments' | translate}}</span>
                    </div>
                  </div>

                  <div class="fullWidthContainer" style="margin-bottom: 20px;">
                    <button class="ModernButton primary" (click)="UpdateAccountingSeries(s);"><i class="material-icons">save_alt</i> {{ 'Configuration.SaveChanges' | translate }}</button>
                  </div>
              </div>
            </div>

            <button class="ModernFab primary" style="margin-right: 10px;" (click)="initializeNewSeries();">
              <i class="material-icons">add</i>
            </button>
           
            <div class="fullWidthContainer" *ngIf="newSeries != null;">
              <div class="thirdContainer" style="width: auto;padding-top: 24px;">
                <div class="auto-save-toggle-container">
                  <label class="auto-save-toggle">
                    <input type="checkbox" [(ngModel)]="newSeries.IsActive">
                    <span class="toggle-slider"></span>
                  </label>
                  <span class="auto-save-label">{{ 'IsActive' | translate }}</span>
                </div>
              </div>

              <div class="thirdContainer">
                <label class="ModernFormLabel">{{ 'DocumentType' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'newSeriesDocType'" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('newSeriesDocType')">
                    <i class="material-icons dropdown-icon-left">description</i>
                    <input type="text" class="CustomDropdownInput" [value]="newSeries.GeneralDocTypeObject?.Name || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="openDropdownId === 'newSeriesDocType'">
                    <div class="CustomDropdownResult" *ngFor="let doc of AccountingMasterData.GeneralDocTypes" (click)="newSeries.GeneralDocTypeObject = doc; openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{doc.Name}}</span></div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="thirdContainer" style="width: 10%;">
                <label class="ModernFormLabel">{{ 'Series' | translate }}</label>
                <div class="PartnerSearchBar">
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="newSeries.Series">
                </div>
              </div>

              <div class="thirdContainer" style="width: 10%;">
                <label class="ModernFormLabel">{{ 'HighestValue' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <input type="text" class="PartnerSearchInput" [(ngModel)]="newSeries.HighestValue" disabled>
                </div>
              </div>

              <div class="thirdContainer">
                <button class="ModernFab primary" (click)="AddNewCompanySeries();">
                  <i class="material-icons">save_alt</i>
                </button>

                <button class="ModernFab danger" style="margin-left: 10px;" (click)="newSeries = null;">
                  <i class="material-icons">close</i>
                </button>
              </div>
            </div>

          </div>
        </div>

        <!-- ========== TAB 3: ADMINISTRATIONS ========== -->
        <div *ngIf="activeTab == 3">
          <div class="loading-container" *ngIf="loading">
            <div class="modern-spinner"></div>
          </div>

          <div class="MainTabBody" *ngIf="!loading">

            <div *ngFor="let a of this.Company.Administrations; index as j" class="fullWidthContainer">

              <div class="thirdContainer" style="width: auto;">
                <i class="material-icons ReceptionProductEdit" (click)="AskDeleteAdministrationQuestion(a);">close</i>
              </div>

              <div class="thirdContainer">
                <label class="ModernFormLabel">{{ 'AdministrationName' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">apartment</i>
                  <input type="text" class="PartnerSearchInput" [(ngModel)]="a.Name" disabled>
                </div>
              </div>

             </div>

             <div class="thirdContainer">
              <button class="ModernFab primary" (click)="initializeNewAdministration();">
                <i class="material-icons">add</i>
              </button>
            </div>

            <div class="fullWidthContainer" *ngIf="newAdministration != null;">

              <div class="thirdContainer" style="width: auto;">
                <i class="material-icons ReceptionProductEdit" (click)="newAdministration = null;">close</i>
              </div>

              <div class="thirdContainer" style="width: 32%;">
                <label class="ModernFormLabel">{{ 'AdministrationName' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">apartment</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="newAdministration.Name">
                </div>
              </div>

              <div class="thirdContainer">
                <button class="ModernFab primary" (click)="AddCompanyAdministration();">
                  <i class="material-icons">save_alt</i>
                </button>
              </div>
            </div>

          </div>

        </div>

        <!-- ========== TAB 4: PARTNERS ========== -->
        <div *ngIf="activeTab == 4">
          <div class="loading-container" *ngIf="loading">
            <div class="modern-spinner"></div>
          </div>

          <div class="MainTabBody" *ngIf="!loading">

            <div class="thirdContainer">
              <button class="ModernButton primary" (click)="OpenNewCompanyRelationship();">
                {{'NewCompanyRelationship' | translate}}
                <i class="material-icons">add</i>
              </button>
            </div>

            <div *ngFor="let r of this.Company.Relationships; index as i" class="fullWidthContainer RelationShipContainer" style="margin-bottom: 25px;">
              
              <div class="fullWidthContainer" style="margin-bottom: 20px;">
                <div class="auto-save-toggle-container">
                  <label class="auto-save-toggle">
                    <input type="checkbox" [(ngModel)]="r.Active">
                    <span class="toggle-slider"></span>
                  </label>
                  <span class="auto-save-label">{{'IsActive' | translate}}</span>
                </div>
              </div>

              <div class="fullWidthContainer" style="margin-bottom: 20px;">
                <div class="auto-save-toggle-container">
                  <label class="auto-save-toggle">
                    <input type="checkbox" [(ngModel)]="r.Automatic">
                    <span class="toggle-slider"></span>
                  </label>
                  <span class="auto-save-label">{{'AutomaticInvoicesReceptionsInsert' | translate}}</span>
                </div>
              </div>

              <div class="fullWidthContainer">
                 <div class="ModernPopupGrid">
                  <div class="ModernFormGroup">
                    <label class="ModernFormLabel">{{ 'MainCompany' | translate }} | Profit: {{r.MasterProfitMargin}}%</label>
                    <div class="CustomDropdownContainer">
                      <div class="CustomDropdownBar disabled">
                        <i class="material-icons dropdown-icon-left">business</i>
                        <input type="text" class="CustomDropdownInput" [value]="Company?.Name || ''" readonly disabled />
                        <i class="material-icons dropdown-icon">arrow_drop_down</i>
                      </div>
                    </div>
                  </div>

                  <div class="ModernFormGroup">
                    <label class="ModernFormLabel">{{ 'SlaveCompany' | translate }} | Profit: {{100 - r.MasterProfitMargin}}%</label>
                    <div class="CustomDropdownContainer">
                      <div class="CustomDropdownBar disabled">
                        <i class="material-icons dropdown-icon-left">business</i>
                        <input type="text" class="CustomDropdownInput" [value]="getDisplayNameById(r.SlaveCompanyID, Companies)" readonly disabled />
                        <i class="material-icons dropdown-icon">arrow_drop_down</i>
                      </div>
                    </div>
                  </div>
                 </div>

                <div class="fullWidthContainer">
                 <div class="PopUpBodyOneThirddContainer">
                  <button class="ModernButton outline" (click)="r.MasterProfitMargin = r.MasterProfitMargin + 1;">+1 Profit</button>
                  <button class="ModernButton outline" (click)="r.MasterProfitMargin = r.MasterProfitMargin - 1;">-1 Profit</button>

                  <button class="ModernButton primary" (click)="UpdateCompanyRelationshipProfitMargin(r);">{{'SaveButton' | translate}}</button>
                 </div>
                </div>

              </div>
            </div>

          </div>

        </div>

        <!-- ========== TAB 5: AUTO PRINT SETTINGS ========== -->
        <div *ngIf="activeTab == 5">
          <div class="loading-container" *ngIf="loading">
            <div class="modern-spinner"></div>
          </div>

          <div class="MainTabBody" *ngIf="!loading">

            <div class="fullWidthContainer">
              <div class="ModernFormGroup" style="width: 45%;">
                <label class="ModernFormLabel">{{ 'AutoPrintSettings' | translate }}</label>
                <div class="CustomDropdownContainer">
                  <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'autoPrint'" (click)="openDropdownId = null"></div>
                  <div class="CustomDropdownBar" (click)="toggleDropdown('autoPrint')">
                    <i class="material-icons dropdown-icon-left">print</i>
                    <input type="text" class="CustomDropdownInput" [value]="this.PrinterSettings?.PrinterName || ''" readonly />
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                  </div>
                  <div class="CustomDropdownResults" *ngIf="openDropdownId === 'autoPrint'">
                    <div class="CustomDropdownResult" *ngFor="let p of this.Company.PrinterSettings" (click)="PrinterSettings = p; SelectPrinterSettings(p); openDropdownId = null;">
                      <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{p.PrinterName}} <span *ngIf="p.UserID?.length > 0">({{'PersonalSettings' | translate}})</span></span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <p *ngIf="this.PrinterSettings?.UserID?.length > 0">
              {{'PersonalSettings' | translate}}
            </p>

            <div class="fullWidthContainer" *ngIf="this.PrinterSettingsUserName?.length > 0;">
              <div class="ModernFormGroup halfWidth">
                <label class="ModernFormLabel">{{ 'UsersSettings' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">person</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.PrinterSettingsUserName">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup halfWidth">
                <label class="ModernFormLabel">{{ 'Partners.Name' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">business</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.Company.Name">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup halfWidth">
                <label class="ModernFormLabel">{{ 'PrinterName' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">print</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="this.PrinterSettings.PrinterName">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup halfWidth">
                <label class="ModernFormLabel">{{ 'APIAddress' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">api</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="this.PrinterSettings.APIAddress">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup halfWidth">
                <label class="ModernFormLabel">{{ 'IPAddress' | translate }}</label>
                <div class="PartnerSearchBar">
                  <i class="material-icons search-icon">lan</i>
                  <input type="text" class="PartnerSearchInput" autocomplete="off" [(ngModel)]="this.PrinterSettings.IPAddress">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer" style="padding-left: 0.5%;">
              <div class="auto-save-toggle-container">
                <label class="auto-save-toggle">
                  <input type="checkbox" [(ngModel)]="this.PrinterSettings.TwoSidedPrint">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label">{{'TwoSidedPrint' | translate}}</span>
              </div>
            </div>

            <div class="fullWidthContainer" style="margin-top: 20px;">
              <div class="ModernFormGroup" style="width: 120px;">
                <label class="ModernFormLabel">Min value</label>
                <div class="PartnerSearchBar">
                  <input type="number" class="PartnerSearchInput" [(ngModel)]="this.PrinterSettings.StandardCopies">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer" style="padding-left: 0.5%;margin-bottom: 20px;">
              <div class="auto-save-toggle-container">
                <label class="auto-save-toggle">
                  <input type="checkbox" [(ngModel)]="this.PrinterSettings.IsTestEnviorment">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label">{{'IsTestEnviorment' | translate}}</span>
              </div>
            </div>

            <div class="fullWidthContainer" style="padding-left: 0.5%;" *ngIf="this.PrinterSettings?.UserID?.length > 0 && this.PrinterSettings?.ID?.length > 0;">
              <div class="auto-save-toggle-container">
                <label class="auto-save-toggle">
                  <input #usePersonal type="checkbox" [(ngModel)]="this.parent.User.Settings.UsePersonalAutoPrintSettings" (change)="toggleUsePersonalAutoPrintSettings({checked: usePersonal.checked})">
                  <span class="toggle-slider"></span>
                </label>
                <span class="auto-save-label">{{'UsePersonalAutoPrintSettings' | translate}}</span>
              </div>
            </div>

          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;">
            <div class="halfWidth">
              <button class="ModernButton accent" (click)="AddUpdatePrinterSettings(this.PrinterSettings);">{{'SaveButton' | translate}}</button>
            </div>
          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;" *ngIf="this.PrinterSettings?.UserID?.length > 0 && this.PrinterSettings.ID == null;">
            <div class="halfWidth">
              <button class="ModernButton outline" (click)="CancelPersonalPrinterSettings();">{{'Cancel' | translate}}</button>
            </div>
          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;" *ngIf="this.PrinterPersonalSettingsExistance == false;">
            <div class="halfWidth">
              <button class="ModernButton primary" (click)="InitializePersonalPrinterSettings(this.PrinterSettings);">
                <i class="material-icons">add</i>
                {{'AddPersonalSettings' | translate}}
              </button>
            </div>
          </div>

        </div>

        <!-- ========== TAB 6: DELETE DATA SETTINGS ========== -->
        <div *ngIf="activeTab == 6">
          <div class="loading-container" *ngIf="loading">
            <div class="modern-spinner"></div>
          </div>

          <div class="MainTabBody" *ngIf="!loading">
           
            <div class="FifteenPercentContainer">
              <label class="ModernFormLabel">{{ 'Receptions.ChoosePeriod' | translate }}</label>
              <div class="CustomDropdownContainer">
                <div class="SendEmailOverlayTransparent" *ngIf="openDropdownId === 'deletePeriod'" (click)="openDropdownId = null"></div>
                <div class="CustomDropdownBar" (click)="toggleDropdown('deletePeriod')">
                  <i class="material-icons dropdown-icon-left">event</i>
                  <input type="text" class="CustomDropdownInput" [value]="Filter.Period?.Name || ''" readonly />
                  <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
                <div class="CustomDropdownResults" *ngIf="openDropdownId === 'deletePeriod'">
                  <div class="CustomDropdownResult" *ngFor="let a of this.AccountingMasterData.Periods;" (click)="Filter.Period = a; AddActiveFilter(a.Name, 'Period'); openDropdownId = null;">
                    <div class="CustomDropdownResultMain"><span class="CustomDropdownResultText">{{a.Name}}</span></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="FifteenPercentContainer">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
                <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp></mat-datepicker>
              </mat-form-field>
            </div>
           
            <div class="FifteenPercentContainer">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                <mat-datepicker #dp1></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="DeletingDocumentContainer" *ngFor="let d of this.DeletingDocuments; index as i">
              <label class="ModernCheckbox">
                <input type="checkbox" [(ngModel)]="d.IsSelected">
                <span class="checkmark"><i class="material-icons">check</i></span>
                <span class="ModernCheckboxLabel">{{d.Name}}</span>
              </label>
            </div>
          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;">
            <div class="halfWidth">
              <button class="ModernButton danger DeleteButton" (click)="GetDeletingEntitiesCount();">{{'DeleteDataButton' | translate}}</button>
            </div>
          </div>

          <div class="fullWidthContainer" style="padding-left: 2.5%;margin-bottom: 10px;">
            <div class="halfWidth">
              <button class="ModernButton danger DeleteButton" (click)="OpenMFACompanyDelete();">{{'DeleteWholeCompany' | translate}}</button>
            </div>
          </div>

        </div>

        <!-- ========== TAB 7: EFACTURA SETTINGS ========== -->
        <div *ngIf="activeTab == 7">

        <div class="halfWidth">
          <div *ngIf="this.EFacturaGeneralData != null;" class="EFacturaSettingsContainer">
            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'CompanyName' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">business</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.Company.Name">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'CallBackUrl' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">link</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.EFacturaGeneralData.CallBackUrl">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'ClientID' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">vpn_key</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.EFacturaGeneralData.ClientID">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'ClientSecret' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">vpn_key</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.EFacturaGeneralData.ClientSecret">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'EToken' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">token</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.EFacturaGeneralData.EToken">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'RefreshToken' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">autorenew</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.EFacturaGeneralData.RefreshToken">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'AuthCode' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">password</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.EFacturaGeneralData.AuthCode">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'ETokenExpiration' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">schedule</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.EFacturaGeneralData.ETokenExpirationUI">
                </div>
              </div>
            </div>

            <div class="fullWidthContainer">
              <div class="ModernFormGroup">
                <label class="ModernFormLabel">{{ 'SigningUser' | translate }}</label>
                <div class="PartnerSearchBar disabled">
                  <i class="material-icons search-icon">person</i>
                  <input type="text" class="PartnerSearchInput" disabled [(ngModel)]="this.EFacturaGeneralData.SigningUser.UIName">
                </div>
              </div>
            </div>
          </div>

          <div class="fullWidthContainer LifeSpanContainer" *ngIf="this.EFacturaGeneralData?.ETokenLifespanList != null">
            <p class="LifeSpanTitle">{{this.EFacturaGeneralData?.DaysUntilExpiration}} {{'DaysUntilExpiry' | translate}}</p>
            
            <div *ngIf="this.EFacturaGeneralData?.ETokenLifespanList?.length > 10" class="LifeSpanUnitbackground">
              <div class="LifeSpanUnit" *ngFor="let unit of this.EFacturaGeneralData.ETokenLifespanList; let i=index;">
              </div>
            </div>
            
            <div *ngIf="this.EFacturaGeneralData?.ETokenLifespanList?.length <= 10 && this.EFacturaGeneralData?.ETokenLifespanList?.length > 5" class="LifeSpanUnitbackground">
              <div style="background: gold;" class="LifeSpanUnit" *ngFor="let unit of this.EFacturaGeneralData.ETokenLifespanList; let i=index;">
              </div>
            </div>

            <div *ngIf="this.EFacturaGeneralData?.ETokenLifespanList?.length <= 5 && this.EFacturaGeneralData?.ETokenLifespanList?.length > 3" class="LifeSpanUnitbackground">
              <div style="background: #f60;" class="LifeSpanUnit" *ngFor="let unit of this.EFacturaGeneralData.ETokenLifespanList; let i=index;">
              </div>
            </div>
              
            <div *ngIf="this.EFacturaGeneralData?.ETokenLifespanList?.length <= 3" class="LifeSpanUnitbackground">
              <div style="background: #fd4f57;" class="LifeSpanUnit" *ngFor="let unit of this.EFacturaGeneralData.ETokenLifespanList; let i=index;">
              </div>
            </div>

            <button style="margin-top: 20px;" [disabled]="this.parent.loading" class="ModernButton primary" (click)="this.ShowANAFRedirectionNotification = true;">
              <i class="material-icons">lock_reset</i>
              {{ 'ResetToken' | translate }}
            </button>
          </div>
        </div>

        <div class="halfWidth" style="padding-top: 20px;">
          <div class="EFacturaSettingSlideContainer">
            <div class="auto-save-toggle-container" matTooltip="{{ 'EFacturaAutomaticSendDesc' | translate }}" matTooltipClass='neutral-tool-tip'>
              <label class="auto-save-toggle">
                <input type="checkbox" [(ngModel)]="this.EFacturaSettings.EFacturaAutomaticSend">
                <span class="toggle-slider"></span>
              </label>
              <span class="auto-save-label">{{'EFacturaAutomaticSend' | translate}}</span>
            </div>
          </div>

          <div class="EFacturaSettingSlideContainer">
            <div class="auto-save-toggle-container" matTooltip="{{ 'EFacturaAutomaticReceiveDesc' | translate }}" matTooltipClass='neutral-tool-tip'>
              <label class="auto-save-toggle">
                <input type="checkbox" [(ngModel)]="this.EFacturaSettings.EFacturaAutomaticReceive">
                <span class="toggle-slider"></span>
              </label>
              <span class="auto-save-label">{{'EFacturaAutomaticReceive' | translate}}</span>
            </div>
          </div>

          <div class="EFacturaSettingSlideContainer">
            <button style="margin-top: 20px;" [disabled]="this.parent.loading" class="ModernButton primary" (click)="AddUpdateCompanyEFacturaSettings();">
              <i class="material-icons">check</i>
              {{ 'Update' | translate }}
            </button>
          </div>
         
        </div>

        </div>

      </div>
    </div>
  </div>
</div>